import React, { useRef, useState, useCallback, useEffect } from "react";

import { Box, Button, CircularProgress, Grid, Paper } from "@mui/material";

import SelectModal from "./SelectModal";
import ChatInput from "./ChatInput";
import ChatHistory from "./ChatHistory";
import ChatPlaceholder from "./ChatPlaceholder";
import ExcerptDisplay from "./ExcerptDisplay";
import ChatMessage from "./ChatMessage";
import LoadingDb from "./LoadingDb";
import { useTheme } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  getChats,
  getconversationid,
  getSelectedIndexes,
} from "../../redux/slices/conversationSlice";
import { getloadingfordb } from "../../redux/slices/loadingSlice";
import { getType } from "../../redux/slices/typeSlice";
import { getHidePageContent } from "../../redux/slices/userSlice";

import VisibilityIcon from "@mui/icons-material/Visibility";
import apiCall from "../../utils/apiCall";
import DataPreviewModal from "./DataPreviewModal";
import { addError } from "../../redux/slices/errorSlice";
import { useMsal } from "@azure/msal-react";

const ChatSection = () => {
  const [showDataPreview, setShowDataPreview] = useState(false);
  const [dataForPreview, setDataForPreview] = useState("");
  const [dataloading, setDataloading] = useState(false);

  const { instance, accounts } = useMsal();

  const conversation_id = useAppSelector(getconversationid);
  const loadingdb = useAppSelector(getloadingfordb);

  const chats = useAppSelector(getChats);
  const chatType = useAppSelector(getType);
  const hidePageContent = useAppSelector(getHidePageContent);

  const selectedIndex = useAppSelector(getSelectedIndexes);
  const dispatch = useAppDispatch();

  const chatContainerRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = useCallback(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [chats, scrollToBottom]);

  const getDataPreview = () => {
    setDataloading(true);
    apiCall("POST", chatType.datapreviewurl, {
      file_name: selectedIndex[0],
      db_name: selectedIndex[0],
      tables: ["all"],
      user_email: accounts[0]?.username,
    })
      .then((res) => {
        setShowDataPreview(true);
        setDataForPreview(res.result);
      })
      .catch((err: any) => {
        dispatch(addError("Failed to load the data preview.Please try again."));
      })
      .finally(() => {
        setDataloading(false);
      });
  };
  const theme = useTheme();
  return (
    <Box
      component="main"
      sx={{
        // flexGrow: 1,
        p: 3,
        background: loadingdb
          ? theme.palette.mode === "dark"
            ? "#222"
            : "rgba(217,217,217,1)"
          : conversation_id
          ? theme.palette.mode === "dark"
            ? "#333"
            : "rgba(217,217,217,.37)"
          : theme.palette.mode === "dark"
          ? "#333"
          : "rgba(217,217,217,.5)",
        height: "calc(100vh)",
        width: !chatType.showSecondary
          ? "calc(100vw - 500px)"
          : hidePageContent
          ? "calc(100vw - 350px)"
          : "calc(100vw - 600px)",
        transition: "width 0.3s ease",
        display: "flex",
        flexDirection: "column",
        paddingTop: "80px",
        pb: 1,
      }}
    >
      {loadingdb ? (
        <LoadingDb />
      ) : conversation_id ? (
        <>
          <Grid
            container
            justifyContent="space-between"
            direction="row"
            mb="7px"
          >
            <Grid container xs>
              <ChatHistory />
              <Grid
                container
                sx={{
                  width: "190px",
                }}
                alignItems="center"
              >
                {chatType.datapreviewurl !== "" &&
                  selectedIndex.length !== 0 && (
                    // <Paper
                    //   sx={{
                    //     my: 0.5,
                    //   }}
                    // >
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      startIcon={<VisibilityIcon />}
                      sx={{
                        m: 0.5,
                      }}
                      onClick={getDataPreview}
                    >
                      Data Preview
                    </Button>
                    // </Paper>
                  )}
                {dataloading && (
                  <CircularProgress
                    size="small"
                    color="primary"
                    sx={{
                      width: "25px",
                      height: "25px",
                    }}
                  />
                )}
              </Grid>
            </Grid>
            <SelectModal />
          </Grid>
          {/* <EnterpriseWarningBanner /> */}
          <Grid
            ref={chatContainerRef}
            flex={1}
            xs={12}
            alignItems="center"
            justifyContent="flex-start"
            sx={{
              overflow: "auto",
            }}
          >
            {chats?.map((chat, i) => (
              <ChatMessage
                message={chat.message}
                who={chat.type}
                key={i}
                sources={chat.sources ?? []}
                model={chat.model}
                chat_type={chat.chat_type}
                org_cypher={chat.org_cypher ?? ""}
                cypher={chat.cypher ?? ""}
                db_creds={
                  chat.db_creds ?? {
                    username: "",
                    url: "",
                    password: "",
                  }
                }
                image_model={chat.image_model ?? ""}
                collection_chunks={chat.collection_chunks ?? []}
                collection_images={chat.collection_images ?? []}
                pii={chat?.pii}
              />
            ))}
            <ExcerptDisplay />
          </Grid>
          <Grid
            container
            sx={{
              overflowX: "auto",
              alignItems: "center",
            }}
          ></Grid>
          <ChatInput
           onScroll={scrollToBottom} />
        </>
      ) : (
        <ChatPlaceholder />
      )}
      <DataPreviewModal
        data={dataForPreview}
        open={showDataPreview}
        setOpen={setShowDataPreview}
      />
    </Box>
  );
};

export default ChatSection;
